<div class="bg-white p-6 mb-8 shadow-sm">
  <div class="flex flex-col lg:flex-row items-start gap-6">
    <div
      class="hidden lg:flex w-16 h-16 rounded-full bg-blue-100 items-center justify-center text-2xl font-semibold text-dc-navy"
    >
      @if (loginUserDetail && loginUserDetail["First Name"]) {
        {{loginUserName ? loginUserName[0] : ''}}
        <!-- {{ loginUserDetail["First Name"][0]
        }}{{ loginUserDetail["Last Name"][0] }} -->
      }
    </div>

    <!-- main info -->
    <div class="flex-1">
      <h2 class="text-xl font-semibold text-dc-navy">
        <!-- {{ loginUserDetail["First Name"] }} {{ loginUserDetail["Last Name"] }} -->
          {{loginUserName}}
      </h2>
      <div class="text-sm text-dc-navy mt-2 space-y-1">
        <div class="flex gap-10">
          @if (loginUserDetail && loginUserDetail["User Type"]) {
            <span>
              <!-- {{ "PROFILE.USERTYPE" | translate }} : -->
              <span>{{ loginUserDetail["User Type"] }}</span>
            </span>
          }
          <span>
            {{ "PROFILE.USERNAME" | translate }} :
            <span class="font-medium">{{ loginUserDetail["Login Name"] }}</span>
          </span>
        </div>
        <div class="flex gap-10">
          @if (loginUserDetail && loginUserDetail["Phone #"]) {
            <span>
              {{ "PROFILE.PHONE" | translate }} :
              <span class="font-medium">{{ loginUserDetail["Phone #"] }}</span>
            </span>
          }
          @if (loginUserDetail && loginUserDetail["DC Nationality"]) {
            <span>
              {{ "PROFILE.ADDRESS" | translate }} :
              <span class="font-medium">{{
                loginUserDetail["DC Nationality"]
              }}</span>
            </span>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- buttons -->
  <div class="mt-6 flex flex-col lg:flex-row gap-4">
    <app-button
      type="button"
      [label]="'PROFILE.BTN.INFO' | translate"
      [classesName]="
        active == 'info'
          ? 'btn-edge-cut btn-width-auto'
          : 'card-edge-cut-white btn-width-auto'
      "
      (onBtnClick)="switch('info')"
    />
    <app-button
      type="button"
      [label]="'PROFILE.BTN.PASSWORD' | translate"
      [classesName]="
        active == 'password'
          ? 'btn-edge-cut btn-width-auto'
          : 'card-edge-cut-white btn-width-auto'
      "
      (onBtnClick)="switch('password')"
    />
    @if (flags.notificationsSettingsEnabled) {
      <app-button
        type="button"
        [label]="'PROFILE.BTN.NOTI' | translate"
        [classesName]="
          active == 'noti'
            ? 'btn-edge-cut btn-width-auto'
            : 'card-edge-cut-white btn-width-auto'
        "
        (onBtnClick)="switch('noti')"
      />
    }
  </div>
</div>

<!-- personal info  -->
@if (active === "info") {
  <section class="bg-white p-6">
    <div class="border-b-2 border-gray-200 flex flex-col items-stretch gap-4 pb-4 mb-4 sm:flex-row sm:items-center sm:justify-between">
      <h3 class="text-lg font-bold text-dc-navy w-full sm:w-auto">
        {{ "PROFILE.INFO.TITLE" | translate }}
      </h3>
      <app-button
        type="button"
        classesName="card-edge-cut-white w-full sm:w-auto"
        [label]="'BUTTONS.UPDATE_INFROMATION' | translate"
        (onBtnClick)="openUpdateProfileModal()"
      />
    </div>
    <table class="dc-table dc-table-list">
      <tbody>
        <tr>
          <td>
            {{ "PROFILE.INFO.FIRST" | translate }}
          </td>
          <td>{{ loginUserName ? loginUserName : loginUserDetail["First Name"] }}</td>
        </tr>
        <!-- <tr>
          <td>
            {{ "PROFILE.INFO.LAST" | translate }}
          </td>
          <td>{{ loginUserDetail["Last Name"] }}</td>
        </tr> -->
        <tr>
          <td>
            {{ "PROFILE.INFO.USERNAME" | translate }}
          </td>
          <td>{{ loginUserDetail["Login Name"] }}</td>
        </tr>
       
        <tr>
          <td>
            {{ "PROFILE.INFO.EID" | translate }}
          </td>
          <td>{{ loginUserDetail["Emirates Id"] ?  loginUserDetail["Emirates Id"] : '-' }}</td>
        </tr>
       
        <tr>
          <td>
            {{ "PROFILE.INFO.EMAIL" | translate }}
          </td>
          <td>{{ loginUserDetail["EMail Addr"] ? loginUserDetail["EMail Addr"] : '-' }}</td>
        </tr>
        <tr>
          <td>
            {{ "PROFILE.INFO.PHONE" | translate }}
          </td>
          <td class="font-semibold text-dc-navy ltr:text-left! rtl:text-right!">
            {{ loginUserDetail["Phone #"] }}
          </td>
        </tr>
        <tr>
          <td>
            {{ "PROFILE.INFO.COUNTRY" | translate }}
          </td>
          <td class="font-semibold text-dc-navy ltr:text-left! rtl:text-right!">
            {{ loginUserDetail["DC Nationality"] }}
          </td>
        </tr>
      </tbody>
    </table>
    <!-- info box -->
    <div class="lg:w-[30%] mt-8">
      <app-validation-message
        type="default"
        [content]="{ title: 'PROFILE.INFO.NOTE' | translate, message: '' }"
        [showbutton]="false"
        [buttonText]="'PROFILE.INFO.CONTACT' | translate"
        (onBtnClick)="gotoContactUs()"
      ></app-validation-message>
    </div>
    <app-button
      classesName="card-edge-cut-white mt-6"
      [label]="'PROFILE.SIGN_OUT' | translate"
      (onBtnClick)="signOut()"
    />
  </section>
}

<!-- notification settings -->
@if (active === "noti") {
  <section class="bg-white p-6">
    <div class="border-b-2 border-gray-200">
      <h3 class="text-lg font-bold text-dc-navy mb-4">
        {{ "PROFILE.NOTI.TITLE" | translate }}
      </h3>
    </div>
    <table class="dc-table-list">
      <tbody>
        @for (n of notificationsList; track n.fieldKey) {
          <tr [class.opacity-60]="n.updating">
            <td>{{ n.labelKey | translate }}</td>
            <td class="text-dc-navy font-medium">
              {{
                n.enabled
                  ? ("PROFILE.NOTI.ON" | translate)
                  : ("PROFILE.NOTI.OFF" | translate)
              }}
            </td>
            <td class="w-24 text-right">
              <span
                class="text-dc-dark-blue underline underline-offset-4"
                [class.pointer-events-none]="n.updating"
                (click)="UpdateNotifictionSettings(n); $event.preventDefault()"
              >
                {{
                  n.updating
                    ? ("PLEASE_WAIT" | translate)
                    : n.enabled
                      ? ("PROFILE.NOTI.TURN_OFF" | translate)
                      : ("PROFILE.NOTI.TURN_ON" | translate)
                }}
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </section>
}

<!-- SECTION: change password -->
@if (active === 'password') {
<section class="bg-white p-6">
  <h3 class="text-lg font-bold text-dc-navy mb-4 border-b border-gray-300 pb-2">
    {{ "PROFILE.PWD.TITLE" | translate }}
  </h3>

  <form [formGroup]="pwdForm" class="max-w-md space-y-6">
    <div>
      <div class="input-control mb-8">
        <app-text-field
          [label]="'PROFILE.PWD.OLD' | translate"
          [control]="pwdForm.get('old')"
          [placeholder]="'PROFILE.PWD.OLD_PH' | translate"
          [type]="'password'"
          [showPasswordToggle]="true"
        ></app-text-field>
      </div>
      <div class="input-control">
        <app-text-field
          [label]="'PROFILE.PWD.NEW' | translate"
          [control]="pwdForm.get('new')"
          [placeholder]="'PROFILE.PWD.NEW_PH' | translate"
          [type]="'password'"
           [showPasswordToggle]="true"
        ></app-text-field>
      </div>
      <div class="input-control mt-8">
        <app-text-field
          [label]="'PROFILE.PWD.CONFIRM' | translate"
          [control]="pwdForm.get('confirm')"
          [placeholder]="'PROFILE.PWD.CONFIRM_PH' | translate"
          [type]="'password'"
          [showPasswordToggle]="true"
        ></app-text-field>
      </div>
    </div>
    @if (showPasswordErrorMsg && passwordErrorMessage) {
      <app-validation-message
        type="error"
        [content]="{ message: passwordErrorMessage }"
        [showbutton]="false"
      ></app-validation-message>
    }
    @if (!passwordSubmitLoader) {
      <app-button
        classesName="btn-edge-cut"
        [label]="'PROFILE.PWD.SUBMIT' | translate"
        (onBtnClick)="changePassword()"
      />
    } @else {
      <app-button
        [type]="'button'"
        [label]="'PLEASE_WAIT' | translate"
        classesName="btn-edge-cut"
        [disabled]="true"
      />
    }
  </form>
</section>
}
@if (updateProfileModal) {
  <div class="dc-modal">
    <div class="dc-modal-container">
      <!-- Close Button -->
      <button
        class="modal-x-button"
        type="button"
        (click)="updateProfileModal = false"
      >
        <i class="fas fa-close"></i>
      </button>
      <!-- Modal Header -->
      <h1 class="section-heading">
        {{ "PROFILE.INFO.TITLE" | translate }}
      </h1>

      <div>
        <form [formGroup]="form" class="max-w-md space-y-6">
          <div class="fields-container">
            <div class="field-control">
              <app-text-field
                [label]="'PROFILE.INFO.NAME_ENGLISH' | translate"
                [control]="form.get('firstName')"
                [placeholder]="'PROFILE.INFO.NAME_ENGLISH' | translate"
                [maxlength]="150"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'PROFILE.INFO.NAME_ARABIC' | translate"
                [control]="form.get('lastName')"
                [placeholder]="'PROFILE.INFO.NAME_ARABIC' | translate"
                [maxlength]="150"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'PROFILE.INFO.EMAIL' | translate"
                [control]="form.get('email')"
                [placeholder]="'PROFILE.INFO.EMAIL' | translate"
                [validationMessages]="{
                  email: 'VALIDATION_MSG.VALID_EMAIL' | translate
                }"
              ></app-text-field>
            </div>
            @if (emailVerificationPending) {
              <div class="field-control">
                <app-verify-email
                  [LoginName]="loginUserDetail['Login Name']"
                  [EmailAddr]="pendingVerificationEmail"
                  [embedded]="true"
                  (verified)="onProfileEmailVerified()"
                  (resendCompleted)="onProfileEmailOtpResent($event)"
                  (timerCompleted)="onProfileEmailTimerCompleted()"
                  (closed)="onProfileEmailVerificationClosed()"
                ></app-verify-email>
              </div>
            }
            <div class="field-control">
              <app-mobile-number
                [label]="'PROFILE.INFO.PHONE' | translate"
                [control]="form.get('phone')"
                [countryCodeControl]="form.get('countryCode')"
                [placeholder]="'PROFILE.INFO.PHONE' | translate"
                [validationMessages]="{
                  mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                  uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate,
                }"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'PROFILE.INFO.EID' | translate"
                [control]="form.get('emiratesId')"
                [placeholder]="'PROFILE.INFO.EID' | translate"
                [maxlength]="15"
                [validationMessages]="{
                  emiratesId: 'VALIDATION_MSG.VALID_EMIRATES_ID' | translate
                }"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-option-field
                [label]="'PROFILE.INFO.COUNTRY' | translate"
                [control]="form.get('country')"
                [placeholder]="'PROFILE.INFO.COUNTRY' | translate"
                [lovType]="lookupKey.COUNTRY"
                [country]="true"
              ></app-option-field>
            </div>
          </div>
          @if (showErrorMsg && errorMessage) {
            <app-validation-message
              type="error"
              [content]="{ message: errorMessage }"
              [showbutton]="false"
            ></app-validation-message>
          }
          @if (!emailVerificationPending && !formSubmitLoader && !duplicateEmailCheckLoader) {
            <app-button
              classesName="btn-edge-cut btn-width-auto"
              [label]="'BUTTONS.SUBMIT' | translate"
              (onBtnClick)="updateProfile()"
            />
          } @else if (!emailVerificationPending) {
            <app-button
              [type]="'button'"
              [label]="'PLEASE_WAIT' | translate"
              classesName="btn-edge-cut  btn-width-auto"
              [disabled]="true"
            />
          }
        </form>
      </div>
    </div>
  </div>
}
